/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  HourglassOutlined,
  // CalendarTwoTone,
  NumberOutlined,
  ThunderboltFilled,
  // EyeTwoTone,
  // SafetyCertificateTwoTone,
} from '@ant-design/icons';
import { Button, Input, message, Modal } from 'antd';
import Form from 'antd/es/form/Form';
import DomainExclusionModal from 'components/domainExclusionModal';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { submitInviteCode } from 'services/api/users';
import DomainContext from 'services/domainContext';
import ProfileContext from 'services/profileContext';
import styles from 'styles/components/onboarding.module.scss';
import { JOINING_FEE_URL, LOCAL_STORAGE } from 'utils/constants';

const UnderReview = ({ close }) => {
  const [whiteListModalOpen, setWhiteListModalOpen] = useState(false);
  const { domains } = useContext(DomainContext);
  const { profile, updateProfile } = useContext(ProfileContext);
  const [loading, setLoading] = useState(false);
  const [showHaveACodeForm, setShowHaveACodeForm] = useState(false);
  const [domainExclusionModalOpen, setDomainExclusionModalOpen] =
    useState(false);

  const navigate = useNavigate();

  const onFinishCode = (values) => {
    setLoading(true);
    submitInviteCode(values.code)
      .then(() => {
        message.success('Code submited successfully');
        return updateProfile();
      })
      .catch((e) => {
        console.error(e);
        message.error('Error while submitting code, please try again.');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // const openModalWhitelist = () => {
  //   setWhiteListModalOpen(true);
  // };

  const goToDashboard = () => {
    close();
    navigate(
      currentDomain && currentDomain?.name.length > 0
        ? `/dashboard?domain=${currentDomain.name}`
        : '/dashboard'
    );
  };

  const [currentDomain, setCurrentDomain] = useState({});
  const currentDomainName = localStorage.getItem(
    LOCAL_STORAGE.CURRENT_DOMAIN_VALIDATION
  );

  useEffect(() => {
    const currentDomainFound = domains.find(
      (d) => d.name === currentDomainName
    );
    setCurrentDomain(currentDomainFound);
  }, [domains]);

  const hasOneValidatedDomain =
    domains?.filter((a) => a.status === 'APPROVED')?.length > 0;
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Travel%20and%20places/Sun%20with%20Face.png"
          alt="Sun with Face"
          width="150"
          height="150"
        />
      </div>
      <h1 className={styles.title}>
        {hasOneValidatedDomain
          ? 'Your new domain is under review'
          : 'Your account is under review'}
      </h1>
      <div style={{ textAlign: 'center' }}>
        {hasOneValidatedDomain
          ? "We’re reviewing your domain and will let you know once it's accepted."
          : profile.hasBeenInvited
          ? ''
          : 'You now have 2 choices:'}

        <br />
      </div>
      <div style={{ textAlign: 'center', marginTop: 14 }}>
        In the meantime, you can keep configuring it and{' '}
        <a
          style={{ color: '#08a87f' }}
          onClick={() => {
            setDomainExclusionModalOpen(true);
          }}
        >
          add domains from which you already have backlinks
        </a>{' '}
        (so that we make sure you don't receive duplicates)
      </div>
      {profile.hasBeenInvited && (
        <div>
          <h2
            className={styles.inviteTitle}
            style={{ marginTop: 22, color: 'white' }}
          >
            ⚡️&nbsp;You've skipped the line because you've been invited&nbsp;
            ⚡️
          </h2>
        </div>
      )}
      {!hasOneValidatedDomain && !profile.hasBeenInvited && (
        <>
          {/* <Divider style={{ borderColor: '#464646' }} /> */}
          <div style={{ marginTop: 24 }}>
            {/* <div className={styles.choicesMainTitle}>2 choices:</div> */}
            <div className={styles.choicesWrapper}>
              <div className={styles.choice}>
                <div className={styles.choiceIcon}>
                  <ThunderboltFilled style={{ color: '#FFD700' }} />
                </div>
                <div className={styles.choiceContent}>
                  <div className={styles.choiceTitle}>
                    1. Skip the line for $19
                  </div>
                  <div className={styles.choiceDescription}>
                    <div>
                      Pay $19 to join now and start exchanging backlinks today.
                    </div>
                  </div>
                  <div className={styles.choiceButton}>
                    <a href={JOINING_FEE_URL} target="_blank" rel="noreferrer">
                      <Button type="primary" icon={<ThunderboltFilled />}>
                        Join now - $19
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
              <div className={styles.choice}>
                <div className={styles.choiceIcon}>
                  <HourglassOutlined />
                </div>
                <div className={styles.choiceContent}>
                  <div className={styles.choiceTitle}>
                    2. Wait until the next round of approvals
                  </div>
                  <div className={styles.choiceDescription}>
                    We will let you know once you’re accepted.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            {!showHaveACodeForm && (
              <div
                style={{ marginTop: 16, textAlign: 'center' }}
                onClick={() => {
                  setShowHaveACodeForm(true);
                }}
              >
                <Button type="link">Someone invited you?</Button>
              </div>
            )}

            {showHaveACodeForm && !profile.hasBeenInvited && (
              <div className={styles.inviteWrapper}>
                <h2 className={styles.inviteTitle}>☝️&nbsp;Have a code?</h2>
                <div>Enter your invite code here to fastrack your review.</div>

                <div className={styles.codeFormWrapper}>
                  <Form
                    layout="inline"
                    style={{ justifyContent: 'center' }}
                    onFinish={onFinishCode}
                  >
                    <Form.Item
                      label={'Have a code?'}
                      name="code"
                      placeholder="Enter the invite code"
                      layout="vertical"
                      rules={[
                        {
                          required: true,
                          message: 'Please input the invite code',
                        },
                      ]}
                    >
                      <Input
                        size={'large'}
                        prefix={<NumberOutlined />}
                        placeholder="123456"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        size={'large'}
                        type="primary"
                        loading={loading}
                        htmlType={'submit'}
                        style={{
                          marginTop: 28,
                        }}
                      >
                        ⚡️&nbsp;Fastrack
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {hasOneValidatedDomain && (
        <div style={{ textAlign: 'center', marginTop: 26 }}>
          <Button
            type="primary"
            onClick={goToDashboard}
            size="large"
            style={{ minWidth: 300 }}
          >
            Go to Dashboard
          </Button>
        </div>
      )}

      <Modal
        open={whiteListModalOpen}
        onCancel={() => {
          setWhiteListModalOpen(false);
        }}
        okText={'Close'}
        footer={
          <Button
            type="primary"
            onClick={() => {
              setWhiteListModalOpen(false);
            }}
          >
            Close
          </Button>
        }
        onOk={() => {
          setWhiteListModalOpen(false);
        }}
        title={'How to whitelist Karmalinks.io email'}
      >
        Follow these steps if you're using Gmail/Google Workspace:
        <ul>
          <li>
            Click the gear icon in Gmail and select "See all settings" from the
            Quick settings menu.
            <div>
              <img src="/img/whitelist.png" alt="whitelist email" />
            </div>
          </li>
          <li>Navigate to "Filters and Blocked Addresses" in the top menu.</li>
          <li>Select "Create a new filter."</li>
          <li>Add a specific email or a whole domain in the "From" field.</li>
          <li>Click "Create filter."</li>
          <li>Whitelist backlinkrequest@karmalinks.io</li>
        </ul>
      </Modal>
      {domainExclusionModalOpen && (
        <DomainExclusionModal
          domain={currentDomain}
          isOpen={domainExclusionModalOpen}
          onClose={() => setDomainExclusionModalOpen(false)}
        />
      )}
    </div>
  );
};
export default UnderReview;
